import React from "react";
import { ReCaptchaProvider } from "@wss/re-captcha";
import { Modal } from "@clarkinc/zest-design-system/ui";
import { User } from "~/common/Store/models/User";
import LoginModal from "./LoginModal";
import loginModalStore from "./loginModalStore";
import { withUserAndChat } from "../Store/connectUserAndChat";
interface Props {
  user: User;
}
const LoginModalWrapper = ({
  user
}: Props) => {
  const modalOpen = loginModalStore.useState(state => state.modalOpen);
  const toggleModal = (open: boolean) => {
    if (open) loginModalStore.openLogin();else loginModalStore.closeLogin();
  };
  return <ReCaptchaProvider data-sentry-element="ReCaptchaProvider" data-sentry-component="LoginModalWrapper" data-sentry-source-file="LoginModalWrapper.tsx">
      <Modal theme="wss" open={modalOpen} onOpenChange={toggleModal} className="box-border w-full xs:max-w-md p-6 xsl:p-10" data-sentry-element="Modal" data-sentry-source-file="LoginModalWrapper.tsx">
        <LoginModal csrfToken={user.csrfToken ?? ""} data-sentry-element="LoginModal" data-sentry-source-file="LoginModalWrapper.tsx" />
      </Modal>
    </ReCaptchaProvider>;
};
export default withUserAndChat(LoginModalWrapper);